import {
  Sort,
  TestCoreFragmentFragment,
  TestSectionModuleLevel,
  TestSortInput,
} from '../../apollo/__generated__/graphql.ts';
import { ISortObj } from '../table/table-utils.ts';

type ISpecialKeys = '_checkbox';
export type ITestsTableKeys =
  | keyof Pick<
      TestCoreFragmentFragment,
      | 'id'
      | 'name'
      | 'description'
      | 'notes'
      | 'created'
      | 'createdAt'
      | 'type'
      | 'questionCount'
      | 'status'
    >
  | ISpecialKeys;
export type ITestsSortKeys = keyof TestSortInput;
export const testsSortKeys: ITestsSortKeys[] = [
  'name',
  'type',
  'questionCount',
  'createdAt',
  'status',
  'id',
  'created',
];

export const initialTestsSort: ISortObj = {
  createdAt: Sort.Desc,
  id: undefined,
  name: undefined,
  type: undefined,
  questionCount: undefined,
  status: undefined,
  created: undefined,
};

type IColumn = {
  title: string;
  key: ITestsTableKeys;
  className?: string;
};
export const testsColumns: IColumn[] = [
  { key: '_checkbox', title: '' },
  { key: 'name', title: 'Name' },
  { key: 'description', title: 'Description' },
  { key: 'notes', title: 'Notes' },
  { key: 'type', title: 'Type', className: 'w-36' },
  { key: 'questionCount', title: 'Questions', className: 'w-24' },
  { key: 'createdAt', title: 'Created At', className: 'w-40' },
  { key: 'status', title: 'Status', className: 'w-28' },
  { key: 'id', title: 'Id', className: 'w-24' },
  { key: 'created', title: 'Created', className: 'w-32' },
];

export const testModuleLevels = [
  TestSectionModuleLevel.All,
  TestSectionModuleLevel.Easy,
  TestSectionModuleLevel.Advanced,
];
